import pluralize from "pluralize"
import { IUser } from "../Auth"
import { TCabPriceCalculationMetric } from "../CabPriceCalculationMetrics"
import { ICabType } from "./../CabTypes"
import { ILocation } from "./../Locations"
import { ITransportService } from "./../TransportServices"
import { createDuration } from "@sembark-travel/datetime-utils"

export interface ITransportServicePrice {
	id: number
	start_date: string
	start_date_local?: string
	end_date: string
	end_date_local?: string
	cab_type_id: number
	cab_type: ICabType
	transport_service_id?: number
	transport_service?: ITransportService
	calculation_metric_id?: number
	calculation_metric?: TCabPriceCalculationMetric
	cab_locality_id?: number
	cab_locality?: ILocation
	per_day_charges?: number
	per_day_parking_charges?: number
	price?: number
	per_km_charges?: number
	minimum_km_per_day?: number
	toll_charges: number
	parking_charges: number
	night_charges: number
	currency: string
	created_at: string
	created_by?: IUser
	is_booking_price: boolean
}

export type TCabPriceCalculatorMetric = {
	id: number
	name: string
	system_metric?: "kms" | "days" | "nights"
	min_quantity_per_day?: number
	prices?: Array<TCabPriceCalculatorMetricPrice>
}

export type TCabPriceCalculatorMetricPreset = {
	id: number
	name: string
	metrics: Array<TCabPriceCalculatorMetric>
}

export type TCabPriceCalculatorMetricPrice = {
	cab_type: ICabType
	currency: string
	price: number
}

export function formatDuration(duration: string): string | undefined {
	if (!duration) return undefined

	const d = createDuration(duration)
	const hrs = Math.floor(d.asHours())
	const mins = d.asMinutes() % 60
	const secs = d.asSeconds() % 60

	const parts: string[] = []

	if (hrs > 0) parts.push(pluralize("hr", hrs, true))
	if (mins > 0) parts.push(pluralize("min", mins, true))
	if (secs > 0) parts.push(pluralize("sec", secs, true))

	return parts.join(" ")
}

export function transformServiceOption(service: ITransportService) {
	return {
		...service,
		label: service.service,
	}
}
